import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { clearSnackbarData, setSnackbarData } from '../store/slices/ui.slice';
import { useAppSelector } from '../store';

export const useSnackbar = () => {
  const dispatch = useDispatch();

  const { snackbar } = useAppSelector(state => state.ui);
  const { message, severity, duration, alertClose } = snackbar;

  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (message) {
      setOpen(true);
    }
  }, [message]);
  const snackbarDuration = duration ?? 3000;

  const setSnackbarMessage = (
    message: string,
    severity: 'success' | 'error' | 'warning' | 'info',
    duration?: number,
    alertClose?: boolean
  ) => {
    dispatch(setSnackbarData({ message, severity, duration, alertClose }));
  };

  const handleOnClear = () => {
    dispatch(clearSnackbarData());
  };

  const handleOnClose = () => {
    setOpen(false);
  };

  return { open, message, severity, snackbarDuration, alertClose, setSnackbarMessage, handleOnClear, handleOnClose };
};
